import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getEqualOrBelowRoles = async (maximumRole: string, includeEqualRole: boolean) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      maximumRole,
      includeEqualRole,
    },
    query: graphql(`
      query GetEqualOrBelowRoles($maximumRole: String, $includeEqualRole: Boolean) {
        getEqualOrBelowRoles(maximumRole: $maximumRole, includeEqualRole: $includeEqualRole)
      }
    `),
  });

  return response.data.getEqualOrBelowRoles;
};
